// GA4 Analytics configuration
export const ga4Config = {
  // GA4 (for advanced analytics)
  ga4MeasurementId: process.env.REACT_APP_GA_MEASUREMENT_ID || "your-vercel-ga4-id",
  apiSecret: process.env.REACT_APP_GA_API_SECRET || "z9AU3dTnS_OmuUUdCNpo_",
  propertyId: process.env.REACT_APP_GA_PROPERTY_ID || "your-ga4-property-id"
}; 